import { normalizePostMedia } from 'services/media';
import { createPermlink  } from "services/dsteem-service";

declare global {
  interface Window {
    steem_keychain: any;
  }
}

import {saveLoginInfo } from "./localStorage"; 
import { getContent } from "services/posts-service";
import { get_post } from "services/db-service";
import steem from '@steemit/steem-js';
import { SP2vests, getExpiration } from "./steem";
const SPEEM_BENEFICIARY = parseFloat(process.env.SPEEM_BENEFICIARY) || 10; 
const SPEEM_BENEFICIARY_ACCOUNT = (process.env.SPEEM_BENEFICIARY_ACCOUNT || "speem").trim().toLowerCase().replace("@", "");
export function keychainProposalVote(voteStatus: boolean, username: string, proposalId: number) {
  return new Promise((resolve, reject) => {
    if (window.steem_keychain && username !== undefined && username !== "") {
      window.steem_keychain.requestUpdateProposalVote(
        username,
        JSON.stringify([proposalId]),
        voteStatus,
        JSON.stringify([]),
        (response: any) => {
          if (response.success) {
            resolve(response.success);
          } else {
            console.log(response);
            resolve(response);
          }
        },
        null
      );
    } else {
      reject(false);
    }
  })
}

export function keychainWitnessVote(voteStatus: boolean, username: string, witness: string) {
  return new Promise((resolve, reject) => {
    if (window.steem_keychain && username !== undefined && username !== "") {
      window.steem_keychain.requestWitnessVote(
        username,
        witness,
        voteStatus,
        (response: any) => {
          if (response.success) {
            resolve(response.success);
          } else {
            console.log(response);
            resolve(response);
          }
        }
      );
    } else {
      reject(false);
    }
  })
}

export function keychainCreateProposal(username: string, receiver: string, subject: string,
  permlink: string, daily_pay: number, start: Date, end: Date) {
  if (window.steem_keychain && username !== undefined && username !== "") {
    window.steem_keychain.requestCreateProposal(
      username,
      receiver,
      subject,
      permlink.replace(/^.*\/(.*)$/, "$1"),
      Number(daily_pay).toFixed(3) + " SBD",
      new Date(start).toISOString(),
      new Date(end).toISOString(),
      JSON.stringify([]),
      (response) => {
        if (response.success) {
          return response;
        } else {
          console.log(response);
          return response;
        }
      },
      null
    );
  } else {
    return;
  }
}

export async function loginKeychain (user: string, message: string) {
  return new Promise((resolve) => {
    if (window.steem_keychain && user !== "") {
      window.steem_keychain.requestSignBuffer(
        user,
        message,
        "Posting",
        (response: any) => { 
          if (response.success) {
            saveLoginInfo(user);
            resolve(response);
          } else {
            resolve(response);
          }
        }
      );
    } else {
      console.log("Keychain needed");
      resolve({ success: false, message: "Keychain extension not found." });
    }
  }) 
}

export async function postCreateKeychain(post: any, username, supporting_benef = true) {
    post = normalizePostMedia(post); 
    return new Promise(async (resolve) => {  
        let author = username;
        if (post.author && post.author != username) {
            author = post.author;
        }
        let permlink;
        if (post.permlink) {
            permlink = post.permlink;
        }else {
           try {
                permlink = await createPermlink(post.title, username);
            } catch (error) {
                console.log(error);
                permlink = "speem-" + new Date().getDate() +"-id-" + Math.random().toFixed(4).substring(2);
            } 
        } 
        console.log(permlink); 
        let cover = post.cover?post.cover:"";
        let metadata = { 
            tags:post.tags || "", 
            app:'speem/1.1', 
            display_type:post.display_type,
            video:post.link || "",
            title:post.title || "", 
            category:post.category,
            image:[cover]
        }
        let ops = [];
        let comment = [
            "comment",
            {
                author:author,
                title:post.title,
                body:post.body,
                parent_author:post.parent_author || "",
                parent_permlink:post.category || post.parent_permlink || "steemvideo",
                permlink: permlink,
                json_metadata:JSON.stringify(metadata)
            }
        ]; 
        ops.push(comment);

        if (post.options && (post.options.rewards != "1" || post.options.beneficiaries.length > 0)){
            console.log('Adding options'); 
            let rewards = post.options.rewards;
            let beneficiaries = post.options.beneficiaries; 
            
            if (supporting_benef) {
              const existing = beneficiaries.find(b => b.account === SPEEM_BENEFICIARY_ACCOUNT);
              if (existing) {
                  // Mantener el mayor % entre el actual y 500
                  existing.weight = Math.max(existing.weight, SPEEM_BENEFICIARY*100);
              } else {
                  beneficiaries.push({account: SPEEM_BENEFICIARY_ACCOUNT, weight: SPEEM_BENEFICIARY*100});
              }
            }
            beneficiaries = beneficiaries.sort((a: any, b: any) => 
                a.account.localeCompare(b.account)
            );
            let max_payout;
            if (rewards != 3) max_payout = '1000000.000 SBD';
            else max_payout = '0.000 SBD'; 
            let pct;
            if (rewards == 1 || rewards == 3) pct = 10000;
            if (rewards == 2) pct = 0;
            beneficiaries = beneficiaries.length > 0?`[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`:`[]`;
            beneficiaries = JSON.parse(beneficiaries);

            let comment_options = ["comment_options",{
                author:username,
                permlink:permlink,
                max_accepted_payout:max_payout,
                allow_votes:true,
                allow_curation_rewards:true,
                percent_steem_dollars:pct, 
                extensions:beneficiaries
            }];

            ops.push(comment_options);
        }else {
          if (supporting_benef) {
            let beneficiaries:any = [];
            beneficiaries.push({account:SPEEM_BENEFICIARY_ACCOUNT, weight:SPEEM_BENEFICIARY*100});
            beneficiaries = beneficiaries.length > 0?`[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`:`[]`;
            beneficiaries = JSON.parse(beneficiaries);
            let rewards = 1;
            let max_payout;
            if (rewards != 3) max_payout = '1000000.000 SBD';
            else max_payout = '0.000 SBD'; 
            let pct;
            if (rewards == 1 || rewards == 3) pct = 10000;
            if (rewards == 2) pct = 0;

            let comment_options = ["comment_options",{
              author:username,
              permlink:permlink,
              max_accepted_payout:max_payout,
              allow_votes:true,
              allow_curation_rewards:true,
              percent_steem_dollars:pct, 
              extensions:beneficiaries
            }];

            ops.push(comment_options);
          }
          
        }
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'posting', async function (response) { 
              if (response.success) { 
                await setTimeout(async () => {
                    let msg = await get_post(username, permlink);
                    console.log(msg); 
                }, 5000); 
                resolve({...response, permlink});
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
} 
export  function accountUpdateKeychain(username: any, newProfile:any ) { 
    return new Promise(async (resolve) => {  
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
    
        try {
            if (account.posting_json_metadata) {
                currentMetadata = JSON.parse(account.posting_json_metadata).profile;
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
    
        const updatedMetadata = {
            profile: {
                ...currentMetadata,
                ...newProfile
            } 
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: account.json_metadata,
            posting_json_metadata: JSON.stringify(updatedMetadata)
        }]);
    
    
        // let tx = {operations: ops, extensions: []};
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', async function (response) { 
              if (response.success) {  
                resolve({success:true, message:"yey"})
              } else {
                resolve({success:false, message:"Failed updating account."})
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export  function createPlaylistKeychain(username: any, newPlaylist:any ) { 
    return new Promise(async (resolve) => {  
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
        let playlists = [];
    
        try {
            if (account.json_metadata) {
                currentMetadata = JSON.parse(account.json_metadata);
                playlists = JSON.parse(account.json_metadata).playlists || [];
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
        const normalizedNewName = newPlaylist.name.trim().toLowerCase();

        const exists = playlists.some((pl:any) =>
        pl?.name?.trim().toLowerCase() === normalizedNewName
        );

        if (exists) {
            return resolve({
                success: false,
                message: "A playlist with this name already exists."
            });
        }

        const idExists = playlists.some((pl:any) => pl.id === newPlaylist.id);

        if (idExists) {
        return resolve({
            success: false,
            message: "Playlist ID already exists"
        });
        }


        playlists.push(newPlaylist);
        const updatedMetadata = { 
                ...currentMetadata,
                playlists  
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        // let tx = {operations: ops, extensions: []};
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', async function (response) { 
              if (response.success) {  
                resolve({success:true, message:"yey"})
              } else {
                resolve({success:false, message:"Failed updating account."})
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export  function editPlaylistKeychain(username: any, editedPlaylist: any, ) { 
    return new Promise(async (resolve) => {  
        let ops = []; 

        const accountRes = await steem.api.callAsync(
          "condenser_api.get_accounts",
          [[username]]
        );
        const account = accountRes[0];
  
        let currentMetadata: any = {};
        let playlists: any[] = [];
  
        try {
          if (account.json_metadata) {
            currentMetadata = JSON.parse(account.json_metadata);
            playlists = currentMetadata.playlists || [];
          }
        } catch {
          currentMetadata = {};
          playlists = [];
        }
  
        const index = playlists.findIndex(
          (pl: any) => pl.id === editedPlaylist.id
        );
  
        if (index === -1) {
          return resolve({
            success: false,
            message: "Playlist not found"
          });
        }
  
        // ⬇️ merge limpio (mantiene items si no los mandas)
        playlists[index] = {
          ...playlists[index],
          ...editedPlaylist,
          edited_at: editedPlaylist.edited_at
        };
        const updatedMetadata = { 
                ...currentMetadata,
                playlists  
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        // let tx = {operations: ops, extensions: []};
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', async function (response) { 
              if (response.success) {  
                resolve({success:true, message:"yey"})
              } else {
                resolve({success:false, message:"Failed updating account."})
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export  function addToPlaylistKeychain(username: any, playlistId: string, newItem = { author: "", permlink: "" } ) { 
    return new Promise(async (resolve) => {  
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
        let playlists = [];
    
        try {
            if (account.json_metadata) {
                currentMetadata = JSON.parse(account.json_metadata);
                playlists = JSON.parse(account.json_metadata).playlists || [];
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
        const playlistIndex = playlists.findIndex(
            (pl: any) => pl.id === playlistId
        );

        if (playlistIndex === -1) {
            return resolve({
            success: false,
            message: "Playlist not found"
            });
        }

        const playlist = playlists[playlistIndex];

        
        if (!Array.isArray(playlist.items)) {
            playlist.items = [];
        }
        
        const alreadyExists = playlist.items.some(
            (item: any) =>
            item.author === newItem.author &&
            item.permlink === newItem.permlink
        );

        if (alreadyExists) {
            return resolve({
            success: false,
            message: "This item is already in the playlist"
            });
        }
        
        playlist.items.push({
            author: newItem.author,
            permlink: newItem.permlink
        }); 

        playlists[playlistIndex] = playlist;
        const updatedMetadata = { 
                ...currentMetadata,
                playlists  
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        // let tx = {operations: ops, extensions: []};
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', async function (response) { 
              if (response.success) {  
                resolve({success:true, message:"yey"})
              } else {
                resolve({success:false, message:"Failed updating account."})
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export  function removeFromPlaylistKeychain(username: any, playlistId: string, itemToRemove = { author: "", permlink: "" } ) { 
    return new Promise(async (resolve) => {  
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
        let playlists = [];
    
        try {
            if (account.json_metadata) {
                currentMetadata = JSON.parse(account.json_metadata);
                playlists = JSON.parse(account.json_metadata).playlists || [];
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
        const playlistIndex = playlists.findIndex(
          (pl: any) => pl.id === playlistId
        );

        if (playlistIndex === -1) {
          return resolve({
            success: false,
            message: "Playlist not found"
          });
        }

        const playlist = playlists[playlistIndex];

        if (!Array.isArray(playlist.items)) {
          playlist.items = [];
        }

        const initialLength = playlist.items.length;

        playlist.items = playlist.items.filter(
          (item: any) =>
            !(
              item.author === itemToRemove.author &&
              item.permlink === itemToRemove.permlink
            )
        );

        if (playlist.items.length === initialLength) {
          return resolve({
            success: false,
            message: "Item not found in playlist"
          });
        }

        playlists[playlistIndex] = playlist;
        const updatedMetadata = { 
                ...currentMetadata,
                playlists  
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        // let tx = {operations: ops, extensions: []};
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', async function (response) { 
              if (response.success) {  
                resolve({success:true, message:"yey"})
              } else {
                resolve({success:false, message:"Failed updating account."})
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}

export function postKeychainVote(author:string,permlink:string, weight:number, voter:string) { 
    return new Promise((resolve) => { 
        let ops = [];
        weight = weight*100;
        let post_vote = [
            "vote",
            {
                "voter": voter,
                author:author,
                permlink:permlink,
                weight:weight
            }
        ];

        ops.push(post_vote);
        if (window.steem_keychain && voter !== "") {
          window.steem_keychain.requestBroadcast(voter, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function commentCreateKeychain(post: any, username: any, comment_callback = true) { 
    return new Promise(async (resolve) => {
        let permlink = "speem-reply-" + Math.random().toFixed(8).substring(4); 
        let metadata = {  
            app:'speem/1.1'
        }
        let ops = [];
        let comment = [
            "comment",
            {
                author:username,
                title:"",
                body:post.body,
                parent_author:post.parent_author,
                parent_permlink:post.parent_permlink,
                permlink: permlink,
                json_metadata:JSON.stringify(metadata)
            }
        ]; 
        ops.push(comment);

        // if (post.options.rewards != "1" || post.options.beneficiaries.length > 0){
        //     console.log('Adding options'); 
        //     let rewards = post.options.rewards;
        //     let beneficiaries = post.options.beneficiaries;
        //     let max_payout;
        //     if (rewards != 3) max_payout = '1000000.000 SBD';
        //     else max_payout = '0.000 SBD'; 
        //     let pct;
        //     if (rewards == 1 || rewards == 3) pct = 10000;
        //     if (rewards == 2) pct = 0;
        //     beneficiaries = `[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`;
        //     beneficiaries = JSON.parse(beneficiaries);

        //     let comment_options = ["comment_options",{
        //         author:username,
        //         permlink:permlink,
        //         max_accepted_payout:max_payout,
        //         allow_votes:true,
        //         allow_curation_rewards:true,
        //         percent_steem_dollars:pct, 
        //         extensions:beneficiaries
        //     }];

        //     ops.push(comment_options);
        // }
        let reply = {};
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'posting', async function (response) { 
              if (response.success) { 
                if (comment_callback) {
                  reply = await getContent(username, permlink);
                }
                resolve({...response, permlink, reply});
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function transferKeychain(username: string, amount, symbol, to, memo) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let transfer = [
            "transfer",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                memo
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function transferToSavingsKeychain(username: string, amount, symbol, to) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let transfer = [
            "transfer_to_savings",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                memo:""
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function withdrawFromSavingsKeychain(username: string, amount, symbol, to) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let request_id = Math.floor(
            (Date.now() / 1000) % 4294967295
        );
        let transfer = [
            "transfer_from_savings",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                request_id,
                memo:""
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function cancelWithdrawFromSavingsKeychain(username: string, request_id) { 
    return new Promise(async (resolve) => { 
        let ops = []; 
        let transfer = [
            "cancel_transfer_from_savings",
            {
                from:username.replace("@", "").toLowerCase(), 
                request_id
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function transferToVestingKeychain(username: string, amount, symbol, to) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let transfer = [
            "transfer_to_vesting",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase()
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function delegateKeychain(username: string, to, sp, mvest) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let transfer = [
            "delegate_vesting_shares",
            {
                delegator:username.replace("@", "").toLowerCase(),
                vesting_shares:SP2vests(sp,mvest,6)+" VESTS",
                delegatee:to.replace("@", "").toLowerCase()
            }
        ]; 
        ops.push(transfer); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function powerDownKeychain(username: string, sp, mvest) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let op = [
            "withdraw_vesting",
            {
                account:username.replace("@", "").toLowerCase(),
                vesting_shares:SP2vests(sp,mvest, 6)+" VESTS"
            }
        ]; 
        ops.push(op); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'active', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function followKeychain(following:any,type:any, username: string) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let follow = [
            "custom_json",
            {
                id:"follow",
                required_auths:[],
                required_posting_auths:[username],
                json:JSON.stringify([
                    "follow",
                    {follower:username, following:following, what:[type]}
                ])
            }
        ]; 
        ops.push(follow); 
        
        if (window.steem_keychain && username !== "") {
          window.steem_keychain.requestBroadcast(username, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function shareKeychain(account:string, author:string, permlink:string) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let follow = [
            "custom_json",
            {
                id:"follow",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    "reblog",
                    {account:account, author:author, permlink:permlink}
                ])
            }
        ]; 
        ops.push(follow); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function markAsReadKeychain(account:string, timeNow:any) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"notify",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    "setLastRead",
                    {date: timeNow}
                ])
            }
        ]; 
        ops.push(mark); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function subscribeKeychain(account:string, community:string,what:any) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community}
                ])
            }
        ]; 
        ops.push(mark); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function pinKeychain(account:string, community:string,what:any,author:string, permlink:string) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community, account:author, permlink}
                ])
            }
        ]; 
        ops.push(mark); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function muteKeychain(account:string, community:string,what:any,author:string, permlink:string) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community, account:author, permlink, notes:what}
                ])
            }
        ]; 
        ops.push(mark); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}

export async function claimKeychain(account:string, steem, sp, sbd) { 
    return new Promise(async (resolve) => { 
        let ops = [];
        let tx = [
            "claim_reward_balance",
            {
                account:account,
                reward_steem:steem,
                reward_sbd:sbd,
                reward_vests:sp
            }
        ]; 
        ops.push(tx); 
        
        if (window.steem_keychain && account !== "") {
          window.steem_keychain.requestBroadcast(account, ops, 'posting', function (response) { 
              if (response.success) { 
                resolve(response);
              } else {
                resolve(response);
              }
            }
          );
        } else {
          resolve(false);
        }
    }) 
}
export async function placeLimitOrderKeychain(
    username: string,
    orderid: number,
    amount_to_sell: string,
    min_to_receive: string,
    fill_or_kill: boolean = false,
    expiration: string = getExpiration()
): Promise<any> {
    return new Promise((resolve) => {
        if (window.steem_keychain && username !== "") {
            window.steem_keychain.requestBroadcast(
                username,
                [['limit_order_create', {
                    owner: username,
                    orderid,
                    amount_to_sell,
                    min_to_receive,
                    fill_or_kill,
                    expiration,
                }]],
                'active',
                (response: any) => {
                    if (response.success) resolve({ success: true, result: response });
                    else resolve({ success: false, message: response.message || String(response) });
                }
            );
        } else {
            resolve({ success: false, message: "Keychain not available or invalid username" });
        }
    });
}

export async function cancelLimitOrderKeychain(
    username: string,
    orderid: number
): Promise<any> {
    return new Promise((resolve) => {
        if (window.steem_keychain && username !== "") {
            window.steem_keychain.requestBroadcast(
                username,
                [['limit_order_cancel', { owner: username, orderid }]],
                'active',
                (response: any) => {
                    if (response.success) resolve({ success: true, result: response });
                    else resolve({ success: false, message: response.message || String(response) });
                }
            );
        } else {
            resolve({ success: false, message: "Keychain not available or invalid username" });
        }
    });
}

export function addPostingAuthorityKeychain(username: string, authorizedAccount: string) {
    return new Promise((resolve) => {
        if (window.steem_keychain && username !== "") {
            window.steem_keychain.requestAddAccountAuthority(
                username,
                authorizedAccount,
                'Posting',
                1,
                (response: any) => {
                    if (response.success) {
                        resolve(response);
                    } else {
                        console.log(response);
                        resolve(response);
                    }
                }
            );
        } else {
            resolve({ success: false, message: "Keychain extension not found." });
        }
    });
}

export function removePostingAuthorityKeychain(username: string, authorizedAccount: string) {
    return new Promise((resolve) => {
        if (window.steem_keychain && username !== "") {
            window.steem_keychain.requestRemoveAccountAuthority(
                username,
                authorizedAccount,
                'Posting',
                (response: any) => {
                    if (response.success) {
                        resolve(response);
                    } else {
                        console.log(response);
                        resolve(response);
                    }
                }
            );
        } else {
            resolve({ success: false, message: "Keychain extension not found." });
        }
    });
}